<template>
  <div class="animated fadeIn">
    <b-form @submit.prevent="onSubmit">
      <b-form-group label="Comments" :label-cols="3" class="mb-3">
        <b-form-textarea
          v-model="$v.form_data.comments.$model"
          rows="4"
        />
      </b-form-group>

      <b-form-group label="Shareable" :label-cols="3" class="mb-3">
        <b-form-select
          v-model="$v.form_data.override_customer_id.$model"
          :options="[
            { value: null, text: 'Yes' },
            { value: customer_id, text: 'No' }
          ]"
        />
      </b-form-group>

      <b-form-group label="Crop" :label-cols="3" class="mb-3">
        <b-form-input
          v-model="$v.form_data.crop.$model"
          name="crop"
          type="text"
          class="form-control"
          placeholder="Crop"
        />
      </b-form-group>

      <b-form-group label="Yield" :label-cols="3" class="mb-3">
        <b-input-group append="Bushels">
          <b-form-input
            v-model="$v.form_data.yield.$model"
            name="yield"
            type="number"
            class="form-control"
            placeholder="Yield"
          />
        </b-input-group>
      </b-form-group>

      <div class="d-flex justify-content-between mb-3">
        <h3 class="mb-0">Elements</h3>

        <b-button variant="success" @click="addElement">
          <i class="fa fa-plus" />
        </b-button>
      </div>

      <div v-for="(v, index) in $v.form_data.recommendation_elements.$each.$iter" :key="index" class="p-3 d-flex align-items-start mb-3" :class="{'bg-white': index % 2 === 0}">
        <div class="flex-grow-1 mr-2">
          <b-form-group label="Element" :label-cols="3" class="mb-3">
            <b-form-input
              v-model="v.element.$model"
              name="element"
              type="text"
              class="form-control"
              placeholder="Element"
              :state="v.element.$dirty && v.element.$invalid ? false : null"
            />
          </b-form-group>

          <b-form-group label="Value" :label-cols="3" class="mb-3">
            <b-form-input
              v-model="v.value.$model"
              name="value"
              type="number"
              class="form-control"
              placeholder="Value"
              :state="v.value.$dirty && v.value.$invalid ? false : null"
            />
          </b-form-group>

          <b-form-group label="Value Unit" :label-cols="3" class="mb-3">
            <b-form-input
              v-model="v.value_unit.$model"
              name="value_unit"
              type="text"
              class="form-control"
              placeholder="Value Unit"
              :state="v.value_unit.$dirty && v.value_unit.$invalid ? false : null"
            />
          </b-form-group>
        </div>

        <div class="d-flex justify-content-end">
          <b-button variant="danger" size="sm" @click="form_data.recommendation_elements.splice(index, 1)">
            <i class="fa fa-trash" />
          </b-button>
        </div>
      </div>

      <!-- validation error -->
      <b-row v-if="validationError">
        <b-col>
          <b-alert variant="danger" show>
            <i class="fa fa-exclamation-triangle" /> Please fill out all required fields.
          </b-alert>
        </b-col>
      </b-row>

      <b-row v-if="error">
        <b-col>
          <b-alert variant="danger" show>
            <i class="fa fa-exclamation-triangle" /> {{ error }}
          </b-alert>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-button variant="success" block :disabled="submittingForm" @click="onSubmit">
            <i v-if="submittingForm" class="fal fa-spinner fa-spin" />
            <span v-else>
              Submit
            </span>
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate/src'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'RecommendationForm',
  mixins: [validationMixin],
  props: {
    submittingForm: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      customer_id: this.$store.getters.getAuthCustomerID,
      form_data: {
        comments: '',
        override_customer_id: this.$store.getters.getAuthCustomerID,
        crop: null,
        yield: null,
        recommendation_elements: [
          {
            element: null,
            value: null,
            value_unit: null,
          }
        ]
      },

      validationError: false
    }
  },
  validations: {
    form_data: {
      comments: {},
      override_customer_id: {},
      crop: {},
      yield: {},
      recommendation_elements: {
        $each: {
          element: { required },
          value: { required },
          value_unit: { required }
        }
      }
    }
  },
  methods: {
    onSubmit () {
      this.validationError = false
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.validationError = true
        return
      }

      this.$emit('submit', this.form_data)
    },

    addElement () {
      this.form_data.recommendation_elements.push({
        element: null,
        value: null,
        value_unit: null,
      })
    },
  }
}
</script>
